import libraryTypes from 'helpers/enums/libraryTypes'

export function formatLibraryType(lti) {
	return lti.teams ? libraryTypes.TEAMS : ( lti.extension ? libraryTypes.EXTENSION : ( lti.canvas ? libraryTypes.LTI : libraryTypes.REGULAR ) )
}
